import _                                                     from 'underscore';
import moment, { Moment }                                    from 'moment';
import React, { FC }                                         from 'react';
import classNames                                            from 'classnames';
import { Icon, IconProps, Popup, PopupProps, SemanticICONS } from 'semantic-ui-react';

import { StyledContainer }            from '../../containers';
import { Align, CorvalUIColor, Size } from '../../../types';
import { TimeService }                from '../../../services';
import { runIfFunction }              from '../../../util';
import { Cell, Grid }                 from 'styled-css-grid';
import { ENTITY_ICONS }               from '../../../constants/ProductEnums';

export interface MilestoneDateIconProps {
	label: string,
	date: string | Moment,
	desc?: string,
	icon?: IconProps,
	popup?: PopupProps,

	onDateClick?: () => void,
	showDateClickOnHover?: boolean,

	onEditClick?: () => void,
	showEditClickOnHover?: boolean,

	onEditClickIcon?: SemanticICONS,
	onDateClickIcon?: SemanticICONS,
}

export const milestoneDateIconDefaultProps: MilestoneDateIconProps = {
	label:                'Milestone Event',
	date:                 null,
	desc:                 null,
	icon:                 {
		name:      ENTITY_ICONS.MILESTONES.ITEM,
		color:     'red',
		className: 'rotate--45',
	},
	popup:                {
		size:      'tiny',
		position:  'top center',
		hoverable: true,
	},
	onDateClick:          null,
	showDateClickOnHover: true,

	onEditClick:          null,
	showEditClickOnHover: true,

	onEditClickIcon: 'pencil',
	onDateClickIcon: 'pencil',
}

const MilestoneDateIcon: FC<MilestoneDateIconProps> = ( props ) => {

	let date = moment.isMoment( props.date ) ? TimeService.asDisplayDate( props.date ) : props.date;

	let iconProps = {
		...milestoneDateIconDefaultProps.icon,
		...props.icon
	};

	let popupProps = {
		...milestoneDateIconDefaultProps.popup,
		...props.popup
	};

	let hasOnDateClick = _.isFunction( props.onDateClick );
	let hasOnEditClick = _.isFunction( props.onEditClick );

	let handleOnDateClick = () => {

		runIfFunction( props.onDateClick );
	}

	let handleOnEditClick = () => {

		runIfFunction( props.onEditClick );
	}

	return (

		<Popup className={ 'peek-container' }
			   popperModifiers={ {
				   preventOverflow: {
					   mainAxis:          false,
					   boundariesElement: "window"
				   }
			   } }
		       trigger={ <Icon { ...iconProps } className={ classNames( 'cursor--pointer', iconProps.className ) }/> }
		       header={ (

			       hasOnEditClick

			       ? <Grid className={ 'header cursor--pointer' } columns={ `25px 1fr 25px` } areas={ [ '. label editIcon' ] } gap={ '5px' } onClick={ handleOnEditClick }>
				       <Cell area={ 'label' }>
					       { props.label }
				       </Cell>
				       <Cell area={ 'editIcon' }>
					       <Icon className={ classNames( { 'peek-item': props.showEditClickOnHover } ) } name={ props.onEditClickIcon } color={ iconProps.color } fitted/>
				       </Cell>
			       </Grid>

			       : props.label

		       ) }
		       content={ (
			       <StyledContainer padding={ [ Size.XS, null, null, null ] } textAlign={ Align.CENTER }>

				       <Grid columns={ 1 } rowGap={ '5px' }>
					       <Cell>

						       { props.date && (

							       <>
								       {/* Clickable date / normal date display */ }
								       { hasOnDateClick

								         ? <Grid columns={ `auto auto auto` }
								                 columnGap={ '8px' }
								                 onClick={ handleOnDateClick }
								                 className={ classNames( 'cursor--pointer' ) }
								                 style={ { margin: 'auto', width: 'fit-content' } }>

									         <Cell middle>
										         <Icon name={ 'calendar alternate outline' } color={ 'grey' } fitted/>
									         </Cell>

									         <Cell middle center>
										         <StyledContainer className={ 'padding-xs-top' }>
											         <strong onClick={ handleOnDateClick } className={ classNames( `text--colored-${ iconProps.color }`, 'cursor--pointer' ) }>{ date }</strong>
										         </StyledContainer>
									         </Cell>

									         <Cell middle>
										         <Icon className={ classNames( { 'peek-item': props.showDateClickOnHover } ) } name={ props.onDateClickIcon } color={ iconProps.color } fitted/>
									         </Cell>
								         </Grid>

								         : <>
									         <Icon name={ 'calendar alternate outline' } color={ 'grey' }/>
									         <strong onClick={ handleOnDateClick } className={ classNames( `text--colored-${ iconProps.color }` ) }>{ date }</strong>
								         </>
								       }
							       </>
						       ) }

					       </Cell>
					       <Cell>

						       { props.desc &&
						       <span className={ 'display--inline-block' }>{ props.desc }</span> }
					       </Cell>
				       </Grid>

			       </StyledContainer>
		       ) }
		       { ...popupProps }/>
	);
};

MilestoneDateIcon.defaultProps = milestoneDateIconDefaultProps;

export { MilestoneDateIcon }
